import template from 'lodash-es/template';

export default (tpl, params, options = {}) => {
  const compiled = template(tpl, options);
  return compiled(params);
};



// WEBPACK FOOTER //
// ./node_modules/cigna_csg_gsg_pagination/src/js/util.js